<template>
  <v-dialog :model-value="wizard.showModal" @update:model-value="close" max-width="600px">
    <v-card>
      <v-card-title class="d-flex align-center justify-space-between">
        <div>Creating Event</div>
      </v-card-title>
      <v-divider class="m-0"></v-divider>
      <v-card-item data-cy="wizard-submit-modal">
        <div class="m-3 d-flex flex-column gap-1">
          <div class="message-item" v-for="(message, i) in wizard.submitMessages" :key="i">
            <span class="message">{{ message.message }}</span>
            <v-icon
              :color="colors[message.status]"
              v-if="message.status == 'error' || message.status == 'success'"
              size="small"
              :data-cy="`wizard-submit-${message.status}`"
            >
              {{ icons[message.status] }}
            </v-icon>
            <v-progress-circular
              v-else
              indeterminate
              color="primary600"
              size="small"
            ></v-progress-circular>
          </div>
        </div>
      </v-card-item>
      <v-card-actions>
        <v-btn v-if="wizard.error" variant="outlined" :loading="wizard.loading" @click="retry"
          >Retry</v-btn
        >
        <v-spacer></v-spacer>
        <v-btn
          variant="flat"
          :loading="wizard.loading"
          @click="close"
          data-cy="wizard-submit-close-btn"
          :data-success="!wizard.error + ''"
          >close</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup lang="ts">
import useWizard from "@/stores/school/wizard";

const wizard = useWizard();

const close = () => {
  if (!wizard.loading) wizard.close();
};
const retry = () => {
  wizard.error = false;
  if (!wizard.loading) wizard.submit();
};

const colors = {
  success: "rgb(0,255,0)",
  error: "rgb(255,0,0)"
};

const icons = {
  success: "mdi-check-circle",
  error: "mdi-alert-circle-outline"
};
</script>

<style scoped lang="scss">
@use "@/assets/_vars.scss" as *;
@use "@/assets/_breakpoints.scss" as breakpoints;

.message-item {
  display: flex;
  align-items: center;
  gap: 20px;
}
</style>
